angular.module('services.utility', []).factory('utility', [function () {

  var utility = {};
  utility.hasError = function(ngModelCtrl){
    return ngModelCtrl && ngModelCtrl.$dirty && ngModelCtrl.$invalid;
  };
  utility.showError = function(ngModelCtrl, err){
    return ngModelCtrl && ngModelCtrl.$dirty && ngModelCtrl.$error[err];
  };
  utility.canSave = function(ngFormCtrl){
    return ngFormCtrl && ngFormCtrl.$dirty && ngFormCtrl.$valid;
  };
  return utility;
}]);



// WEBPACK FOOTER //
// ./client/src/common/services/utility.js